// extracted by mini-css-extract-plugin
export default {"searchContainer":"DashboardSearch-module__searchContainer--lF_IA"};